import React from "react";
import adhaar from "../../../assets/images/abha-imgs/adhaar.png";
import DL from "../../../assets/images/abha-imgs/DL.png";

import AddButton from "../../buttons/button";

function Method({ setMethod, setStatus, setPosition, closeModal }) {
  return (
    <div className="h-full flex flex-col  ">
      <div className="h-full flex-1 flex items-center justify-center">
        <div className="w-full flex flex-col gap-6 ">
          <div className=" flex flex-col justify-center items-center gap-4 w-full text-center">
            <label
              className={`
                 text-[length:var(--abha-method-title-fs)] font-[var(--abha-method-title-fw)] whitespace-nowrap`}
            >
              Create Your ABHA Number
            </label>
            <label
              className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-sub-title-fs)] font-[var(--abha-method-sub-title-fw)] whitespace-nowrap`}
            >
              Select your verification method
            </label>
          </div>
          <div className="flex flex-row gap-3 justify-center w-full">
            <div
              className="flex flex-col justify-center items-center gap-5 p-6 border 
          border-[var(--abha-method-card-border-color)] rounded-lg 
                flex-1   min-w-[250px] max-w-[700px]"
            >
              <img
                src={adhaar} // put your image in public/images
                alt="ABHA Logo"
                className="w-16 h-16 rounded-[4px] shadow-lg"
              />
              <div className="flex flex-col justify-center items-center gap-2 w-full text-center">
                <label
                  className={`
                 text-[length:var(--abha-method-card-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap`}
                >
                  Create using Aadhaar
                </label>
                <label
                  className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                >
                  Instant creation via Aadhaar-linked mobile
                </label>
              </div>
              <AddButton
                prefixIcon={false}
                // ref={submitRef}
                // isDisabled={disabled}
                // icon={<Save size={14} />}
                onclkFn={() => {
                  setStatus("Aadhar Details");
                  setPosition(1);
                  setMethod("adhaar");
                }}
                text={<span>Select Aadhar</span>}
                className="w-full
    justify-center items-center flex  px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                type="button"
              />
            </div>
            <div
              className="flex flex-col justify-center items-center gap-5 p-6 border border-[var(--abha-method-card-border-color)] rounded-lg 
                 flex-1   min-w-[250px] max-w-[700px]"
            >
              <img
                src={DL} // put your image in public/images
                alt="ABHA Logo"
                className="w-16 h-16 rounded-[4px] shadow-lg"
              />
              <div className="flex flex-col justify-center items-center gap-2 w-full text-center">
                <label
                  className={`
                 text-[length:var(--abha-method-card-title-fs)] font-[var(--abha-method-card-title-fw)] whitespace-nowrap`}
                >
                  Create using Driving License
                </label>
                <label
                  className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-card-sub-title-fs)] font-[var(--abha-method-card-sub-title-fw)] whitespace-nowrap`}
                >
                  Use your Driving License for ABHA creation
                </label>
              </div>
              <AddButton
                prefixIcon={false}
                // ref={submitRef}
                // isDisabled={disabled}
                onclkFn={() => {
                  setMethod("driving");
                  setStatus("Mobile Number");
                  setPosition(1);
                }}
                text={<span>Select Driving License </span>}
                className="w-full
    justify-center items-center flex  px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                type="button"
              />
            </div>
          </div>
          <div className="flex justify-center">
            <label
              className={`text-[var(--abha-nav-fg)]
                 text-[length:var(--abha-method-label-fs)] font-[var(--abha-method-label-fw)] whitespace-nowrap`}
            >
              By proceeding, you consent to share your identity details as per
              ABDM guidelines.
            </label>
          </div>
        </div>
      </div>
      <div className="flex  justify-end  mt-auto mb-6">
        <AddButton
          prefixIcon={false}
          text={"Cancel"}
          onclkFn={() => closeModal()}
          className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--trans-stats-con-red-fg)] cursor-pointer
    text-white
    text-[length:var(--draft-button-fs)] 
    font-[var(--draft-button-fw)]
    "
          type="button"
        />
      </div>
    </div>
  );
}

export default Method;
